/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrderListRequest } from '../types/PatchedOrderList';
import type { OrderListResponse } from '../types/OrderList';

export type OrdersRetryProcessingPartialUpdateRequest = PatchedOrderListRequest;
export type OrdersRetryProcessingPartialUpdateResponse = OrderListResponse;

export type OrdersRetryProcessingPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/orders/{id}/retry_processing/
 *
 * ```yaml
 * operationId: orders_retry_processing_partial_update
 * description: |-
 *   metoda patch, bez parametru
 *   vrati zmeneny stav objednavky
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderList'
 *     description: ''
 * ```
 */
export const ordersRetryProcessingPartialUpdateOperation = ({
  id,
  ...rest
}: OrdersRetryProcessingPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/orders/${id}/retry_processing/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/retry_processing/' };
  };

/**
 * PATCH /dmx-server/orders/{id}/retry_processing/
 *
 * ```yaml
 * operationId: orders_retry_processing_partial_update
 * description: |-
 *   metoda patch, bez parametru
 *   vrati zmeneny stav objednavky
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderList'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderList'
 *     description: ''
 * ```
 */
export const ordersRetryProcessingPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersRetryProcessingPartialUpdateQuery;
  request: PatchedOrderListRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderListResponse>> => {
  const operation = ordersRetryProcessingPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
